<template>
  <v-layout fluid fill-height>
    <v-row v-show="loading">
      <v-col cols="12" style="text-align:center;">
        <v-progress-circular :size="100" :width="7" color="green" indeterminate></v-progress-circular>
      </v-col>
    </v-row>
    <v-row v-show="!loading">
      <v-col cols="6" v-if="$store.getters.test('struct.m')" class="company-tree">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="searchCompany"
          shaped
          outlined
          clearable
          color="black"
          background-color="yellow lighten-5"
          :label="$t('field.pattern')"
          :placeholder="$t('search.companies')"
        ></v-text-field>
        <v-btn
          v-if="$store.getters.test('CompanyRecord.c')"
          fab
          dark
          color="pink"
          @click="insertRecord('CompanyRecord')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-treeview :items="cmpStruct" :search="searchCompany" :filter="filterComp" activatable>
          <template v-slot:label="{ item, active }">
            <v-btn text :color="item.status != '100' ? 'error' : 'brouwn'">
              <v-icon v-if="item.type == 'CompanyRecord'">fa-city</v-icon>
              <v-icon v-else-if="item.type == 'SubCompanyRecord'">fa-store</v-icon>
              <v-icon v-else-if="item.type == 'TerminalRecord'">fa-cash-register</v-icon>
              <v-icon v-else-if="item.type == 'TerminalDetailRecord'">fa-cog</v-icon>
              <v-icon v-else>mdi-help</v-icon>
              {{ item.name }}
              <v-btn
                v-if="active && $store.getters.test(item.type)"
                icon
                text
                class="ml-2"
                @click="editRecord(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="active && item.type != 'TerminalDetailRecord' && testCreate(item.type)"
                icon
                text
                @click="insertChild(item)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn
                v-if="item.type == 'TerminalDetailRecord'"
                icon
                text
                @click="showLinkedSystem(item)"
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </v-btn>
          </template>
        </v-treeview>
      </v-col>
      <v-col cols="6" v-if="$store.getters.test('struct.s')" class="system-tree">
        <v-text-field
          v-model="searchSystems"
          prepend-inner-icon="mdi-magnify"
          shaped
          outlined
          clearable
          color="black"
          background-color="yellow lighten-5"
          :label="$t('field.pattern')"
          :placeholder="$t('search.system')"
        ></v-text-field>
        <v-btn
          v-if="$store.getters.test('SystemRecord.c')"
          fab
          dark
          color="pink"
          @click="insertRecord('SystemRecord')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-treeview :items="sysStruct" :search="searchSystems" :filter="filterSys" activatable>
          <template v-slot:label="{ item, active }">
            <v-btn text :color="item.status != '100' ? 'error' : 'brown'">
              <v-icon v-if="item.type == 'SystemRecord'">fa-cogs</v-icon>
              <v-icon v-else-if="item.type == 'SystemDetailRecord'">fa-cog</v-icon>
              <v-icon v-else>mdi-help</v-icon>
              {{ item.name }}
              <v-btn
                v-if="active && $store.getters.test(item.type)"
                icon
                text
                class="ml-2"
                @click="editRecord(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="active && item.type != 'SystemDetailRecord' && $store.getters.test('SystemDetailRecord.c')"
                icon
                text
                @click="insertChild(item)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn
                v-if="active && item.type == 'SystemRecord'"
                icon
                text
                @click="insertChild(item, 99999)"
              >
                <v-icon>mdi-account-plus-outline</v-icon>
              </v-btn>
            </v-btn>
          </template>
        </v-treeview>
      </v-col>
    </v-row>
    <v-dialog v-model="editDialog" fullscreen>
      <component
        ref="edt"
        :is="editType"
        v-bind="dialogParams"
        v-model="editDialog"
        @update="onUpdateRecord"
        @insert="onInsertRecord"
        @delete="onDeleteRecord"
      ></component>
    </v-dialog>
  </v-layout>
</template>

<script>
import app from "@/app.js";
import * as components from "@/components/editTypes";
const CMP_TYPES = [
  "CompanyRecord",
  "SubCompanyRecord",
  "TerminalRecord",
  "TerminalDetailRecord",
];
function compare(a, b) {
  if (a.name > b.name) return 1;
  if (a.name < b.name) return -1;
  return 0;
}

const BreakException = {
  obj: null,
  setObj(o) {
    this.obj = o;
    return this;
  },
};

export default {
  components: { ...components },
  data() {
    return {
      editWidth: "800px",
      searchCompany: "",
      searchSystems: "",
      editDialog: false,
      dialogParams: {},
      editType: "BaseRecord",
      cmpStruct: [],
      sysStruct: [],
      loading: true,
    };
  },
  computed: {
    filterSys() {
      return (i, q /*, f*/) => {
        return (
          (i.bin ? i.bin.indexOf(q) != -1 : false) ||
          i.name.toLowerCase().indexOf(q.toLowerCase()) != -1 ||
          i.id.toLowerCase().indexOf(q.toLowerCase()) != -1
        );
      };
    },
    filterComp() {
      return (i, q /*, f*/) => {
        return (
          i.name.toLowerCase().indexOf(q.toLowerCase()) != -1 ||
          i.id.toLowerCase().indexOf(q.toLowerCase()) != -1
        );
      };
    },
  },
  created() {
    if (this.$route.query.sys) {
      this.searchSystems = this.$route.query.sys;
    }
  },
  methods: {
    showLinkedSystem(i) {
      this.searchSystems = i.fk1;
    },
    updateStruct() {
      this.loading = true;
      app
        .loadStruct()
        .then((response) => {
          this.loading = false;
          this.setStructData(response);
          this.$store.commit("struct/SET_STRUCT", response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setStructData(payload) {
      let state = {};
      state.structData = payload;
      // system tree
      let ch = [];
      state.systemsMap = {};
      state.systems = [];
      try {
        state.sysdets = {};
        payload.opers.forEach((o) => {
          o.type = "SystemDetailRecord";
          state.sysdets[o.id] = o;
          if (!ch[o.fk]) ch[o.fk] = [];
          ch[o.fk].push(o);
        });
        payload.systems.forEach((o) => {
          o.type = "SystemRecord";
          if (ch[o.id]) {
            o.children = ch[o.id];
            o.children.sort(compare);
          }
          state.systemsMap[o.id] = o.name;
          state.systems.push(o);
        });
        state.systems.sort(compare);
      } catch (e) {
        console.log("system", e.message);
      }
      //this.$store.commit("struct/SET_SYSTEMS", state.systems);
      // companies tree
      try {
        ch = [];
        state.termdets = {};
        payload.termdets.forEach((o) => {
          o.type = "TerminalDetailRecord";
          if (state.systemsMap[o.fk1]) {
            o.name1 = o.name;
            o.name = state.systemsMap[o.fk1];
          }
          state.termdets[o.id] = o;
          if (!ch[o.fk]) ch[o.fk] = [];
          ch[o.fk].push(o);
        });
        //this.$store.commit("struct/SET_TERMDETS", state.termdets);
        let ch1 = [];
        state.terminals = {};
        payload.terms.forEach((o) => {
          o.type = "TerminalRecord";
          if (ch[o.id]) {
            o.children = ch[o.id];
            o.children.sort(compare);
          }
          state.terminals[o.id] = o;
          if (!ch1[o.fk]) ch1[o.fk] = [];
          ch1[o.fk].push(o);
        });
        ch = [];
        state.subcompanies = {};
        payload.scomps.forEach((o) => {
          o.type = "SubCompanyRecord";
          if (ch1[o.id]) {
            o.children = ch1[o.id];
            o.children.sort(compare);
          }
          state.subcompanies[o.id] = o;
          if (!ch[o.fk]) ch[o.fk] = [];
          ch[o.fk].push(o);
          state.subcompanies[o.id] = o;
        });
        state.companies = [];
        payload.comps.forEach((o) => {
          o.type = "CompanyRecord";
          if (ch[o.id]) {
            o.children = ch[o.id];
            o.children.sort(compare);
          }
          state.companies.push(o);
        });
        state.companies.sort(compare);
      } catch (e) {
        console.log("mercants", e);
      }
      this.cmpStruct = state.companies;
      this.sysStruct = state.systems;
    },
    onUpdateRecord(i) {
      try {
        let obj = null;
        switch (i.recType) {
          case "SystemRecord":
          case "SystemDetailRecord":
            obj = this.findNode(this.sysStruct, i.id);
            if (obj) {
              obj.name = i.name;
              obj.status = i.status;
            }
            break;
          case "CompanyRecord":
          case "SubCompanyRecord":
          case "TerminalRecord":
          case "TerminalDetailRecord":
            obj = this.findNode(this.cmpStruct, i.id);
            if (obj) {
              obj.name = i.name;
              obj.status = i.status;
            }
            break;
        }
        this.$root.$emit("show_snack", {
          color: false,
          msg: this.$t("msg.update.ok"),
        });
      } catch (e) {
        console.log(e);
      }
    },
    onInsertRecord(i) {
      let parent = null;
      try {
        switch (i.recType) {
          case "SystemRecord":
            this.sysStruct.push(i);
            break;
          case "SystemDetailRecord":
            parent = this.findNode(this.sysStruct, i.fk);
            if (parent == null) return;
            if (!parent.children) {
              this.$set(parent, "children", []);
            }
            parent.children.push(i);
            break;
          case "CompanyRecord":
            this.cmpStruct.push(i);
            break;
          case "SubCompanyRecord":
          case "TerminalRecord":
          case "TerminalDetailRecord":
            parent = this.findNode(this.cmpStruct, i.fk);
            if (parent == null) return;
            if (!parent.children) {
              this.$set(parent, "children", []);
            }
            parent.children.push(i);
            break;
        }
        this.$root.$emit("show_snack", {
          color: false,
          msg: this.$t("msg.insert.ok"),
        });
      } catch (e) {
        console.log(e);
      }
    },
    onDeleteRecord(i) {
      try {
        let ind = -1;
        let arr = null;
        let parent = null;
        switch (i.recType) {
          case "SystemRecord":
            arr = this.sysStruct;
            break;
          case "SystemDetailRecord":
            parent = this.findNode(this.sysStruct, i.fk);
            if (parent == null) return;
            arr = parent.children;
            break;
          case "CompanyRecord":
            arr = this.cmpStruct;
            break;
          case "SubCompanyRecord":
          case "TerminalRecord":
          case "TerminalDetailRecord":
            parent = this.findNode(this.cmpStruct, i.fk);
            if (parent == null) return;
            arr = parent.children;
            break;
        }
        if (arr) {
          ind = arr
            .map((e) => {
              return e.id;
            })
            .indexOf(i.id);
          if (ind != -1) arr.splice(ind, 1);
        }
        this.$root.$emit("show_snack", {
          color: false,
          msg: this.$t("msg.delete.ok"),
        });
        // }
      } catch (e) {
        console.log(e);
      }
    },
    testChild(i) {
      let node = this.findNode(this.cmpStruct, i.id);
      if (node) {
        console.log(node);
        node.name += "-";
      }
    },
    findNode(o, id) {
      try {
        if (!id || !Array.isArray(o)) return null;
        o.forEach((el) => {
          if (el.type == "TerminalRecord") {
            if (el.name == id) throw BreakException.setObj(el);
          } else {
            if (el.id == id) throw BreakException.setObj(el);
          }
          if (el.children) {
            let o1 = this.findNode(el.children, id);
            if (o1 != null) throw BreakException.setObj(o1);
          }
        });
      } catch (e) {
        if (e === BreakException) return e.obj;
      }
      return null;
    },
    editRecord(i) {
      if (!this.$store.getters.test(i.type + ".r")) return;
      let pk = i.id;
      if (i.type == "TerminalRecord") pk = i.name;
      app
        .select(pk, i.type)
        .then((response) => {
          if (response.valid_)
            response.validExt = this.$moment(response.valid_).toDate();
          this.dialogParams = {
            record: response,
          };
          this.editType = response.recType;
          //this.editWidth = i.type == "SystemDetailRecord" ? "1900px" : "800px";
          this.editWidth = "800px";
          this.editDialog = true;
        })
        .catch((error) => {
          console.log("item=", error);
        });
    },
    insertRecord(type, parent, operNr) {
      if (!this.$store.getters.test(type + ".c")) return;
      app
        .create(type)
        .then((response) => {
          response.type = response.recType; // for icon
          if(operNr) response.operNr = operNr;
          if (parent) response.fk = parent.id;
          // if (response.valid_)
          //   response.validExt = this.$moment(response.valid_).toDate();
          this.dialogParams = {
            record: response,
            isnew: true,
          };
          //          this.editWidth = type == "SystemDetailRecord" ? "1900px" : "800px";
          this.editWidth = "800px";
          this.editType = response.recType;
          this.editDialog = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    testCreate(t) {
      let k = CMP_TYPES.indexOf(t);
      if (k < CMP_TYPES.length) {
        return this.$store.getters.test(CMP_TYPES[k + 1] + ".c");
      }
      return false;
    },
    /** oper_nr only for anketa oper - 99999 */
    insertChild(parent, operNr) {
      try {
        if (parent.type == "SystemRecord") {
          if (!this.$store.getters.test("SystemDetailRecord.c")) return;
          this.insertRecord("SystemDetailRecord", parent, operNr);
        } else {
          let k = CMP_TYPES.indexOf(parent.type);
          if (k < CMP_TYPES.length) {
            if (!this.$store.getters.test(CMP_TYPES[k + 1] + ".c")) return;
            this.insertRecord(CMP_TYPES[k + 1], parent);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.updateStruct();
  },
};
</script>
<style lang="scss">
.company-tree {
  background-image: url("../assets/strukt_back.svg");
  background-position-x: center;
}
.system-tree {
  background-image: url("../assets/system_back.svg");
  background-position-x: center;
}
</style>
